import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AccountDetail from '../Home/AccountDetail';
import History from '../History/History';
import AccountManagement from '../Account/AccountManagement';
import Wallet from '../Wallet/Wallet';
import { withToast } from './Toast';
import LoginForm from '../Login/LoginForm';
import CreateAccount from '../Login/CreateAccount';
import ChangePassword from '../Login/ChangePassword';
import InstaPay from '../Login/Instapay/InstaPay';
import GuestPay from '../Login/Instapay/GuestPay';
import { useSecurityStatus } from '../../hooks/security';
import Dashboard from '../Dashboard/Dashboard';
import Login from '../Login/Login';
import { handleError, retrieveData, storeData } from './Functions';
import PaymentPage from '../Payments/PaymentPage';
import { PaymentBox } from '../Login/PaymentBox';
import { BillingAccountsVService } from '../../services/V3/gozer';

export const Routing = ({errorToast, successToast}) => {
    const auth = useSecurityStatus();
    let [loading, setLoading] = useState<boolean>(false);
    let [accounts, setAccounts] = useState<any[]>([]);
    let [account, setAccount] = useState<any>(null);
    
    useEffect(() => {
        if (auth.user) {
            getAccounts()
        } else if (!auth.user){
            setAccount(null)
            setAccounts([])
        }
    }, [auth.user])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (loading && auth.user) {
            getAccounts()
        } else if (!auth.user){
            setAccount(null)
            setAccounts([])
        }
    }, [loading])// eslint-disable-line react-hooks/exhaustive-deps

    const getAccounts = () => {
        let currentAccount = retrieveData("billingAccount");
        BillingAccountsVService
            .billingAccountsVGetMinimumByUserId(auth.user.id)
            .then((accts: any) => {
                setAccounts(accts)
                if(currentAccount && currentAccount.userId === auth.user.id){
                    let act = accts.find(x => x.id === currentAccount.id)
                    if(!act) {
                        BillingAccountsVService.billingAccountsVGetById(accts[0].id)
                            .then((fullAcct: any) => {
                                setAccount(fullAcct)
                                storeData("billingAccount", fullAcct)
                            })
                            .catch(err => errorToast(handleError(err)))
                    } else {
                        BillingAccountsVService.billingAccountsVGetById(act.id)
                            .then((fullAcct: any) => {
                                setAccount(fullAcct)
                                storeData("billingAccount", fullAcct)
                            })
                            .catch(err => errorToast(handleError(err)))
                    }
                } else {
                    BillingAccountsVService.billingAccountsVGetById(accts[0].id)
                            .then((fullAcct: any) => {
                                setAccount(fullAcct)
                                storeData("billingAccount", fullAcct)
                            })
                            .catch(err => errorToast(handleError(err)))
                }
                setLoading(false)
            })
            .catch(err => err.message !=="Not Found" && errorToast(handleError(err)))
    }
    
    return (
        <>
            {auth.authed ? ((account && auth.user) ?
                    <Dashboard
                        accounts={accounts}
                        account={account}
                        setAccount={setAccount}
                        errorToast={errorToast}>
                        <Switch>
                            <Route path="/account">
                                <AccountDetail account={account} />
                            </Route>
                            <Route path="/payment">
                                <PaymentPage account={account} />
                            </Route>
                            <Route path="/history">
                                <History
                                    account={account} />
                            </Route>
                            <Route path="/wallet">
                                <Wallet account={account} />
                            </Route>
                            <Route path="/manage">
                                <AccountManagement
                                    account={account}
                                    getAccounts={getAccounts} />
                            </Route>
                            <Route>
                                <Redirect to={"/account"} />
                            </Route>
                        </Switch>
                    </Dashboard>: null) :
                        <Switch>
                            <Route path="/sign-in">
                                <Login>
                                    <LoginForm fail={errorToast} success={successToast} />
                                </Login>
                            </Route>
                            <Route path="/sign-up">
                                <Login>
                                    <CreateAccount fail={errorToast} />
                                </Login>
                            </Route>
                            <Route path="/reset/:resetId">
                                <Login>
                                    <ChangePassword />
                                </Login>
                            </Route>
                            <Route path="/guest-pay">
                                <Login>
                                    <GuestPay />
                                </Login>
                            </Route>
                            <Route path="/instaPay/:accountId/:guestPay">
                                <PaymentBox>
                                    <InstaPay />
                                </PaymentBox>
                            </Route>
                            <Route>
                                <Redirect to="/sign-in" />
                            </Route>
                        </Switch>
            }
       </>
    );
}
export default withToast(Routing);